export default {
  CREATED: 'CREATED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
};
